// Sidebar store — collapse state and active navigation key.
// `collapsed` is persisted to localStorage (non-sensitive UI preference).

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  collapsed: boolean;
  activeKey: string;
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
  setActive: (key: string) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set, get) => ({
      collapsed: false,
      activeKey: '',

      toggle: () => set({ collapsed: !get().collapsed }),
      setCollapsed: (collapsed) => set({ collapsed }),
      setActive: (activeKey) => set({ activeKey }),
    }),
    {
      name: 'bancorix:sidebar',
      // Persist only the collapse preference, not the active key.
      partialize: (state) => ({ collapsed: state.collapsed }),
    },
  ),
);
